import {ModelloDocumento} from "../types";

export interface AmbitoMandato {
    id: string;
    label: string;
    clientType: 'Privato' | 'Azienda' | null; // null = entrambi
    categoria: string; // corrisponde a CategoriaMandato
}

export const ambitiMandato: AmbitoMandato[] = [
    { id: 'privato',          label: 'Ambito Privato',           clientType: 'Privato', categoria: 'AMBITO PRIVATO' },
    { id: 'aziendale',        label: 'Ambito Aziendale',         clientType: 'Azienda', categoria: 'AMBITO AZIENDALE' },
    { id: 'commerciale',      label: 'Ambito Commerciale',       clientType: null,      categoria: 'AMBITO COMMERCIALE' },
    { id: 'assicurativo',     label: 'Ambito Assicurativo',      clientType: null,      categoria: 'AMBITO ASSICURATIVO' },
    { id: 'difensivo',        label: 'Indagini Difensive',       clientType: null,      categoria: 'INDAGINI DIFENSIVE' },
    { id: 'leggi-speciali',   label: 'Leggi Speciali',           clientType: null,      categoria: 'LEGGI SPECIALI' },
    { id: 'info-commerciali', label: 'Informazioni Commerciali', clientType: null,      categoria: 'INFORMAZIONI COMMERCIALI' },
];

export const modelliDocumenti: ModelloDocumento[] = [
    {
        id: 'mand-investigativo',
        nome: 'MANDATO INVESTIGATIVO',
        descrizione: '',
        tipo: 'Preventivo',
        campiRichiesti: [
            { key: 'budget_massimo', label: 'Budget Massimo Cliente', tipo: 'currency', placeholder: '€' },
            { key: 'acconto', label: 'Acconto Richiesto', tipo: 'currency', placeholder: '€' },
            { key: 'tariffa_oraria', label: 'Tariffa Oraria Applicata', tipo: 'currency', placeholder: 'Default: € 50,00' },
        ]
    },
    //{
    //    id: 'info-privacy',
    //    nome: 'MANDATO INVESTIGATIVO - STUDI LEGALI',
    //    descrizione: '',
    //    tipo: 'Informativa',
    //    campiRichiesti: [
    //        { key: 'titolare_dati', label: 'Titolare Trattamento', tipo: 'text', placeholder: 'Nome dell\'agenzia o investigatore' },
    //    ]
    //},
    {
        id: 'prev-bonifiche',
        nome: 'INCARICO BONIFICHE: AMBIENTALI, AUTO, SMARTPHONE',
        descrizione: '',
        tipo: 'Preventivo',
        campiRichiesti: [
            { key: 'mq_locali', label: 'Metri Quadri Locali', tipo: 'number', placeholder: 'mq' },
            { key: 'num_veicoli', label: 'Numero Veicoli da bonificare', tipo: 'number' },
        ]
    },
    {
        id: 'prev-consulenza',
        nome: 'INCARICO ATTIVITÀ DI CONSULENZA',
        descrizione: '',
        tipo: 'Preventivo',
        campiRichiesti: [
            { key: 'ore_stimate', label: 'Ore Stimate', tipo: 'number', placeholder: 'h' }
        ]
    },
];


/*
export const modelliDocumenti: ModelloDocumento[] = [
    {
        id: 'prev-standard',
        nome: 'AMBITO PRIVATO',
        descrizione: '',
        tipo: 'Preventivo',
        campiRichiesti: [
            { key: 'budget_massimo', label: 'Budget Massimo Cliente', tipo: 'currency', placeholder: '€' },
            { key: 'acconto', label: 'Acconto Richiesto', tipo: 'currency', placeholder: '€' },
            { key: 'tariffa_oraria', label: 'Tariffa Oraria Applicata', tipo: 'currency', placeholder: 'Default: € 50,00' },
        ]
    },
    {
        id: 'mand-investigativo',
        nome: 'AMBITO AZIENDALE',
        descrizione: '',
        tipo: 'Preventivo',
        campiRichiesti: [
            { key: 'budget_massimo', label: 'Budget Massimo Cliente', tipo: 'currency', placeholder: '€' },
            { key: 'acconto', label: 'Acconto Richiesto', tipo: 'currency', placeholder: '€' },
            { key: 'tariffa_oraria', label: 'Tariffa Oraria Applicata', tipo: 'currency', placeholder: 'Default: € 50,00' },
        ]
    },
    {
        id: 'prev-consulenza2',
        nome: 'AMBITO COMMERCIALE',
        descrizione: '',
        tipo: 'Preventivo',
        campiRichiesti: [
            { key: 'budget_massimo', label: 'Budget Massimo Cliente', tipo: 'currency', placeholder: '€' },
            { key: 'acconto', label: 'Acconto Richiesto', tipo: 'currency', placeholder: '€' },
            { key: 'tariffa_oraria', label: 'Tariffa Oraria Applicata', tipo: 'currency', placeholder: 'Default: € 50,00' },
        ]
    },
    {
        id: 'prev-ASSICURATIVO',
        nome: 'AMBITO ASSICURATIVO',
        descrizione: '',
        tipo: 'Preventivo',
        campiRichiesti: [
            { key: 'budget_massimo', label: 'Budget Massimo Cliente', tipo: 'currency', placeholder: '€' },
            { key: 'acconto', label: 'Acconto Richiesto', tipo: 'currency', placeholder: '€' },
            { key: 'tariffa_oraria', label: 'Tariffa Oraria Applicata', tipo: 'currency', placeholder: 'Default: € 50,00' },
        ]
    },
    {
        id: 'prev-consulenza2',
        nome: 'AMBITO INDAGINI DIFENSIVE',
        descrizione: '',
        tipo: 'Preventivo',
        campiRichiesti: [
            { key: 'budget_massimo', label: 'Budget Massimo Cliente', tipo: 'currency', placeholder: '€' },
            { key: 'acconto', label: 'Acconto Richiesto', tipo: 'currency', placeholder: '€' },
            { key: 'tariffa_oraria', label: 'Tariffa Oraria Applicata', tipo: 'currency', placeholder: 'Default: € 50,00' },
        ]
    },
    {
        id: 'prev-consulenza2',
        nome: 'AMBITO LEGGI SPECIALI',
        descrizione: '',
        tipo: 'Preventivo',
        campiRichiesti: [
            { key: 'budget_massimo', label: 'Budget Massimo Cliente', tipo: 'currency', placeholder: '€' },
            { key: 'acconto', label: 'Acconto Richiesto', tipo: 'currency', placeholder: '€' },
            { key: 'tariffa_oraria', label: 'Tariffa Oraria Applicata', tipo: 'currency', placeholder: 'Default: € 50,00' },
        ]
    },
    {
        id: 'prev-consulenza2',
        nome: 'INFORMAZIONI COMMERCIALI',
        descrizione: '',
        tipo: 'Preventivo',
        campiRichiesti: [
            { key: 'budget_massimo', label: 'Budget Massimo Cliente', tipo: 'currency', placeholder: '€' },
            { key: 'acconto', label: 'Acconto Richiesto', tipo: 'currency', placeholder: '€' },
            { key: 'tariffa_oraria', label: 'Tariffa Oraria Applicata', tipo: 'currency', placeholder: 'Default: € 50,00' },
        ]
    },
];*/